/**
 * Utilidades centralizadas para manejo de autenticación
 */

/**
 * Limpia toda la información de sesión del localStorage
 */
const clearSession = (): void => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('user');
  localStorage.setItem('sessionExpired', 'true');
};

/**
 * Callback global para manejar logout desde interceptores
 * Se puede configurar desde el componente principal
 */
let globalLogoutCallback: (() => void) | null = null;

/**
 * Configura el callback global de logout
 */
export const setGlobalLogoutCallback = (callback: () => void): void => {
  globalLogoutCallback = callback;
};

/**
 * Ejecuta el logout global
 * Si hay un callback configurado, lo usa
 * Si no, usa window.location.href como fallback
 */
export const executeLogout = (): void => {
  clearSession();

  if (globalLogoutCallback) {
    globalLogoutCallback();
  } else {
    // Fallback: usar window.location si no hay callback configurado
    window.location.href = '/login';
  }
};

